// Legend title text for the BPM TV surface.
// Port of the legendText branches in BrandPerceptialMapping.Tv.ChartView `renderChart`
// (bpm/tv/chart.coffee L83/L84, L103/L104, L108). Pure.

import {
  noTextPlaceholder,
  removeLogicFromText
} from '@aytm/app/stats/page/question-views/components/charts/highcharts/lib/textUtils'
import { decodeText } from '@aytm/app/stats/lib/util/helpers'

// version >= 3 → Bayesian averaged scores; otherwise total scores (legacy mds.version gate)
const isBayesian = answer => answer?.mds?.version != null && answer.mds.version >= 3

export const entityLegendText = answer =>
  isBayesian(answer) ? 'Bayesian averaged scores for each entity' : 'Total scores for each entity'

export const attributeLegendText = answer =>
  isBayesian(answer) ? 'Bayesian averaged scores for each attribute' : 'Total scores for each attribute'

// plotBy 'e', specific value: decode(removeLogic(text) || placeholder)
export const variantLegendText = qv => decodeText(removeLogicFromText(qv.text ?? '') || noTextPlaceholder(qv))

// plotBy 'a', specific value: decode(removeLogic(text)) — no placeholder fallback (legacy L104)
export const batchLegendText = batch => decodeText(removeLogicFromText(batch.text ?? ''))
